// Import all workflow templates
import queryLoopSetVariable from './query-loop-set-variable.json';

// Export templates array with all available templates
export const workflowTemplates = [
  queryLoopSetVariable,
  // Add more templates here as they are created
];

// Helper function to get templates by category
export const getTemplatesByCategory = (category) => {
  return workflowTemplates.filter(template => template.metadata.category === category);
};

// Helper function to get all categories
export const getCategories = () => {
  const categories = new Set(workflowTemplates.map(template => template.metadata.category));
  return Array.from(categories).sort();
};

// Helper function to get template by name
export const getTemplateByName = (name) => {
  return workflowTemplates.find(template => template.metadata.name === name);
};
